import { CustomClients } from '@thehubz/shared/branding';
import { AnyType } from '@thehubz/shared/model';

export function arraysEqual(array1: AnyType[], array2: AnyType[]) {
  if (!(array1 instanceof Array && array2 instanceof Array)) return false;
  return array1.length === array2.length && array1.every((item) => array2.some((obj) => JSON.stringify(obj) === JSON.stringify(item)));
}

export function handleGeneralInformation(updateForm: AnyType, updateData: AnyType, brandingKey: CustomClients): AnyType {
  if (updateForm.generalInformation) {
    const assetStatus = updateForm.generalInformation.status?.id ?? updateForm.generalInformation.status;
    if (assetStatus) updateForm.generalInformation.status = assetStatus;
    if (brandingKey !== CustomClients.VKB) {
      updateData = { ...updateData, ...updateForm.generalInformation };
    }
  }
  return updateData;
}

export function getStatusOrAwaitingApproval(obj: AnyType): string | undefined {
  if (Object.keys(obj).length === 0) {
    return undefined;
  }
  return obj.status ? obj.status : 'awaiting_approval';
}

export function findCommonValues(arrays: string[][]) {
  if (arrays.length === 0) return [];
  return arrays.reduce((commonValues, currentArray) => {
    return commonValues.filter((value) => currentArray.includes(value));
  });
}
